// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610131902/js/" + chunkId + "." + {"44":"aa86a606","225":"040c8fc7","481":"6c85fbc1","486":"564a1dec","770":"b8ed33a2"}[chunkId] + ".0.5357980709667411.chunk.js";
};